import { Skeleton } from "@components/skeleton";
import { AvatarImageSize } from ".";
import { FC } from "react";
interface AvatarLoaderProps {
  size?: AvatarImageSize;
}
const AvatarLoader: FC<AvatarLoaderProps> = ({ size }) => {
  if (!size || size === "small") {
    return <Skeleton style={{ borderRadius: " 50%", height: "40px", width: "40px" }} />;
  }
  if (size === "medium") {
    return <Skeleton style={{ borderRadius: " 50%", height: "60px", width: "60px" }} />;
  }
  if (size === "profile") {
    return (
      <div className="d-flex gap-4">
        <Skeleton style={{ borderRadius: " 50%", height: "40px", width: "40px" }} />
        <Skeleton style={{ borderRadius: " 50%", height: "40px", width: "40px" }} />
      </div>
    );
  }

  return <Skeleton style={{ borderRadius: " 50%", height: "100px", width: "100px" }} />;
};

export default AvatarLoader;
